export default "__VITE_ASSET__1b310822__"